import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import apiClient from "../utils/apiClient";
import useLocalStorage from "../helpers/localStorageHook";
import useUser from "../helpers/useUser";

export default function MarketPlaceBar({ showSearch=false, storesCount=0, searchPlaceholder="ابحث باسم المتجر ..." ,setSelectedUnit, selectedUnit, store=false }) {

    const [showDropDown, setShowDropDown] = useState(false);
    const [user, setUser] = useUser();
    
    const [searchParams] = useSearchParams();
    const querySearch = searchParams.get('search') || "";

    const [localStore, setLocalStore, clareLocalStore] = useLocalStorage('selectedUnit');

    const navigate = useNavigate();
    const handleClicDropDown = () => {
        setShowDropDown(!showDropDown)
    }


    const handleClickStore = (id,name,lat,long) => {
        setSelectedUnit({id: id, name: name, lat: lat, long: long});
        setLocalStore({id: id, name: name, lat: lat, long: long});
        setShowDropDown(false);
    }

    const [unitsOptions, setUnitsOptions] = useState([]);
    const getUnits = async () => {
        try {
            const response = await apiClient.get(`/b-units?business=${user?.business?._id ? user?.business._id : user?.business}`);
            if(response?.data) {
            setUnitsOptions(response?.data?.filter(u=>!u?.deletedAt)?.map(unit => ({value: unit?._id, label: unit?.name, lat: unit?.addressDetails?.location?.latitude, long: unit?.addressDetails?.location?.longitude})));
            }
        } catch(err) {}
    }
    useEffect(()=>{
        getUnits();
    },[])

    useEffect(()=>{
        if(localStore) {
            setSelectedUnit(localStore);
        }
    },[localStore])

    const handleInputChange = (e) => {
        const value = e.target.value;
        navigate(`?search=${encodeURIComponent(value)}`, { replace: true });
    };

    return (
        <div className="rounded-[8px] bg-white h-[56px] flex flex-nowrap">
             <div className="leading-[50px] h-[50px] text-grey-900 font-[500] text-[20px] ps-[10px] pe-[25px] mt-[3px] border-e-[1px] border-e-grey-200 whitespace-nowrap">
                {store ? 'كل المنتجات': 'كل المتاجر'} 
                <span className="text-orange"> {`(${storesCount})`}</span>
             </div>
             <div className="flex-auto relative ps-[25px] pe-[35px]">
                {showSearch && <>
                    <input type="text" className="outline-none leading-[50px] h-[50px] mt-[3px] w-full text-[18px] text-grey-600 font-[400]" placeholder={store ? 'ابحث باسم المنتج...' : searchPlaceholder} value={querySearch} onChange={handleInputChange} />
                    <span className="absolute end-[35px] top-[16px] w-[24px] h-[24px] select-none cursor-pointer !bg-center !bg-no-repeat" style={{background:"url('/assets/images/search-icon.svg')"}}></span>
                </>}
             </div>
             {!store && <div className="w-[258px] rounded-e-[8px] bg-blue cursor-pointer text-center text-white leading-[56px] text-[18px] font-[700] relative pe-[52px]" onClick={()=>handleClicDropDown()}>

                <div className="w-[210px] px-[15px] text-center overflow-hidden text-ellipsis whitespace-nowrap select-none">
                    {selectedUnit ? 'توصيل لـ: '+selectedUnit?.name : 'اختر وحدة'}
                </div>
                <span className="w-[22px] h-[32px] absolute top-[12px] end-[10px]" style={{background: "url('/assets/images/drop-arrow.svg')"}}></span>
                {showDropDown && <div className="absolute z-[1] shadow-[0px_25px_35px_0px_rgba(0,0,0,0.03)] top-[56px] left-[0px] rounded-b-[8px] w-[258px] bg-white border border-grey-300 py-[8px] px-[12px] text-center text-grey-600 font-[500] text-[14px]">
                    <ul>
                        {unitsOptions && Array.isArray(unitsOptions) && unitsOptions?.length > 0 
                            ? unitsOptions?.map((unit,index)=>{
                                return (<li key={'storeDrop-'+unit?.value} className={`text-start leading-[48px] px-[8px] cursor-pointer select-none font-[500] text-[16px] text-grey-400 ${index !== unitsOptions?.length-1 ? 'border-b-[1px] border-b-grey-200' : ''} ${selectedUnit?.id === unit?.value ? '!text-blue font-[900]' : ''}`} onClick={()=>handleClickStore(unit?.value,unit?.label,unit?.lat,unit?.long)}>{unit?.label}</li>)
                            })
                            : <li></li>}
                    </ul>
                </div>}
             </div>}
        </div>
    )
}